import AjaxMultiselect from './components/AjaxMultiselect.vue';
import CompleteDateTime from './components/CompleteDateTime.vue';
import FieldComponent from './components/FieldComponent.vue';
import FilterField from './components/FilterField.vue';
import FilterItem from './components/FilterItem.vue';
import axios_token from "@/services/axios_token";
import mdiVue from "mdi-vue/v2";
import * as mdijs from "@mdi/js";
import MdiIcon from "@/components/MdiIcon.vue";
import {filter_euro_func, filter_moment, filter_moment_it} from "@/filters/moment-format";
import {formatBytesFunction} from "@/filters/formatBytes";


const install = (Vue) => {
    Vue.component('AjaxMultiselect', AjaxMultiselect);
    Vue.component('CompleteDateTime', CompleteDateTime);
    Vue.component('FieldComponent', FieldComponent);
    Vue.component('FilterField', FilterField);
    Vue.component('FilterItem', FilterItem);
    Vue.component('MdiIcon', MdiIcon);
    Vue.component("mdi-icon", MdiIcon);
    Vue.use(mdiVue, {
        icons: mdijs,
    });
    Vue.filter("euro", filter_euro_func);
    Vue.filter("datef", filter_moment);
    Vue.filter("dateonly", filter_moment_it);
    Vue.filter("formatBytes", formatBytesFunction);
    Vue.prototype.$axios = axios_token;
};

// Auto-install when vue is found (eg. in browser via <script> tag)
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use({install});
}

export default {
    install,
    axios_token,
};